var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"style"},[_c('iframe',{staticClass:"style",attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }